export enum FORM_FIELD {
  CHANNEL = 'channel',
  PRODUCT = 'product',
  KPI = 'kpi',
  TARGETING_DETAILS = 'targetingDetails',
  COUNTRY = 'country',
  CURRENCY = 'currency',
  DSP = 'dsp'
}
